import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVisaComponent } from './simple-icons-visa.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVisaComponent ],
    exports:      [ SimpleIconsVisaComponent ],
    bootstrap:    []
})
export class SimpleIconsVisaModule {}
